import { useEffect, useState } from 'react';
import { isAssistantAvailable } from './plugin';
import { closeAssistant, openAssistant, toggleAssistant, OpenAssistantProps } from './sidebar';

export type AssistantHook = {
  isAvailable: boolean;
  openAssistant: ((props: OpenAssistantProps) => void) | undefined;
  closeAssistant: (() => void) | undefined;
  toggleAssistant: ((props: OpenAssistantProps) => void) | undefined;
};
/**
 * Hook to check if the assistant is available and return the open, close, and toggle functions.
 * @returns {AssistantHook}
 */
export function useAssistant(): AssistantHook {
  const [isAvailable, setIsAvailable] = useState(false);

  useEffect(() => {
    const sub = isAssistantAvailable().subscribe((available: boolean) => setIsAvailable(available));
    return () => {
      sub.unsubscribe();
    };
  }, []);

  return {
    isAvailable,
    openAssistant: isAvailable ? openAssistant : undefined,
    closeAssistant: isAvailable ? closeAssistant : undefined,
    toggleAssistant: isAvailable ? toggleAssistant : undefined,
  };
}
